export type PaginationWindow = (number | "...")[];

const ELLIPSIS = "..." as const;

export const getPaginationWindow = (
    current: number,
    total: number,
): PaginationWindow => {
    if (total <= 0) return [];
    if (total <= 7) {
        return Array.from({ length: total }, (_, i) => i + 1);
    }

    const window: PaginationWindow = [1];

    const start = Math.max(2, current - 1);
    const end = Math.min(total - 1, current + 1);

    if (start > 2) window.push(ELLIPSIS);

    for (let p = start; p <= end; p++) window.push(p);

    if (end < total - 1) window.push(ELLIPSIS);

    window.push(total);
    return window;
};
